import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';

import { PlanningService } from '../services/planning.service';
import { PlanningWish } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class PlanningWishListResolverService implements Resolve<PlanningWish[]> {

    constructor(private planningService: PlanningService) { }

    resolve(route: ActivatedRouteSnapshot) {
        const period = route.paramMap.get('period');
        const wishes: PlanningWish[] = [];
        return new Promise<PlanningWish[]>((resolve, reject) => {
            this.planningService.wishList(+period).subscribe(
                wish => wishes.push(wish),
                error => reject(error),
                () => resolve(wishes)
            );
        });
    }
}
